import { TranslationPipe } from './translationPipe';
import { SecondsPipe } from './secondsPipe';

export const ALL_PIPES = [
    TranslationPipe,
    SecondsPipe,
];
